import { useState, useCallback } from 'react';
import * as TargetComplianceService from 'react/services/TargetComplianceService';

const useComplianceModal = ({ queryData, setQueryData, interestType, targetsCommon, $scope, $state }) => {
  const [openComplianceModal, setOpenComplianceModal] = useState(false);
  const [nonCompliantPhrases, setNonCompliantPhrases] = useState({});

  const handleCloseCompliance = useCallback(() => setOpenComplianceModal(false), []);

  const handleSaveWithNonCompliant = useCallback(() => {
    if (queryData.selected.length) {
      if ($scope?.query) $scope.query.selected = queryData.selected;
      targetsCommon.addToCurrentTarget({ state: $state, scope: $scope, skipCompliance: true });
      TargetComplianceService.addNonCompliantPhrases(nonCompliantPhrases);
    } else {
      targetsCommon.clearSelection($scope);
    }
    handleCloseCompliance();
  }, [queryData, nonCompliantPhrases, handleCloseCompliance, $scope, $state, targetsCommon]);

  const handleSaveWithoutNonCompliant = useCallback(() => {
    const filteredSelected = queryData.selected.filter((p) => {
      const tab = interestType === 'searches' ? 'phrases' : interestType;
      const phrase = TargetComplianceService.entityText(p, tab);
      return TargetComplianceService.isPhraseObjCompliance($scope.complianceResults[phrase]);
    });
    setQueryData((prev) => ({ ...prev, selected: filteredSelected }));
    setNonCompliantPhrases({});
    handleSaveWithNonCompliant();
  }, [queryData, interestType, $scope, setQueryData, handleSaveWithNonCompliant]);

  return {
    openComplianceModal,
    setOpenComplianceModal,
    handleCloseCompliance,
    handleSaveWithNonCompliant,
    handleSaveWithoutNonCompliant,
  };
};

export default useComplianceModal;
